var constants = require('../constants');
var api = require('../../../utils/api');
var routerActions = require('react-router-redux').routerActions;
var authCurrentUserActions = require('./auth-current-user');
var educationActions = require('../../education/actions/education');
var authActions = require('./auth-login');
var commonActions = require('../../common/actions/common');

var authFacebook = (function() {

    var _authFacebookRequest = function() {
        return {
            type: constants.AUTH_FACEBOOK_REQUEST
        };
    }

    var _authFacebookSuccess = function(data, source, analyticsLabelSuffix) {
        return {
            type: constants.AUTH_FACEBOOK_SUCCESS,
            data: data,
            meta: {
                analytics: {
                    eventType: source === 'Register' ? constants.AUTH_REGISTER_SUCCESS : constants.AUTH_LOGIN_SUCCESS,
                    actionValue: 'Success',
                    labelValue: 'Facebook' + (analyticsLabelSuffix ? ' ' + analyticsLabelSuffix : '')
                }
            }
        };
    }

    var _authFacebookError = function(error, source, analyticsLabelSuffix) {
        return {
            type: constants.AUTH_FACEBOOK_FAILURE,
            errors: error.data,
            meta: {
                analytics: {
                    eventType: source === 'Register' ? constants.AUTH_REGISTER_FAILURE : constants.AUTH_LOGIN_FAILURE,
                    actionValue: 'Failure',
                    labelValue: 'Facebook' + (analyticsLabelSuffix ? ' ' + analyticsLabelSuffix : '')
                }
            }
        };
    }

    var _authFacebook = function(accessToken, source, redirectUrl, analyticsLabelSuffix) {
        return function(dispatch) {
            dispatch(_authFacebookRequest());
            api.post('/proxy/auth/facebook', {
                    "access_token": accessToken,
                })
                .then(function(data) {
                    dispatch(authActions.loginSuccess(data, false));
                    dispatch(_authFacebookSuccess(data, source, analyticsLabelSuffix));
                    dispatch(authCurrentUserActions.fetchCurrentUser(data.access_token));

                    if(redirectUrl !== 'no-redirect'){
                        if(redirectUrl){
                            dispatch(routerActions.replace(redirectUrl));
                        }else{
                            if(data.newUser){
                                dispatch(routerActions.replace('/surveys/promis'));
                            }else{
                                dispatch(routerActions.replace('/education'));
                            }
                        }
                    }

                    if(data.newUser){
                        dispatch(educationActions.setThanksRegisteringMessage());
                    }
                })
                .catch(function(error) {
                    if(error.response){
                        dispatch(_authFacebookError(error.response, source, analyticsLabelSuffix));
                    }else{
                        dispatch(commonActions.setGenericError('', error.message));
                    }
                });
        };
    }

    return {
        authFacebook: _authFacebook
    }
})();

module.exports = authFacebook;



// WEBPACK FOOTER //
// ./src/common/modules/auth/actions/auth-facebook.js